var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvolutionOfEnergyConsumptionBarchartDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 456.38 201.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{clip-path:url(#clippath-51);}.cls-2{clip-path:url(#clippath-34);}.cls-3{clip-path:url(#clippath-38);}.cls-4{clip-path:url(#clippath-21);}.cls-5{clip-path:url(#clippath-6);}.cls-6{clip-path:url(#clippath-7);}.cls-7{clip-path:url(#clippath-17);}.cls-8{clip-path:url(#clippath-31);}.cls-9{stroke:#d1d3d4;stroke-width:.5px;}.cls-9,.cls-10,.cls-11{fill:none;}.cls-12{clip-path:url(#clippath-15);}.cls-13{clip-path:url(#clippath-33);}.cls-14{clip-path:url(#clippath-61);}.cls-15{clip-path:url(#clippath-18);}.cls-16{clip-path:url(#clippath-47);}.cls-17{clip-path:url(#clippath-4);}.cls-18{fill:#333;}.cls-19{clip-path:url(#clippath-22);}.cls-20{clip-path:url(#clippath-23);}.cls-21{clip-path:url(#clippath-54);}.cls-22{clip-path:url(#clippath-66);}.cls-23{fill:#08b7eb;}.cls-24{fill:#00aab1;}.cls-25{clip-path:url(#clippath-9);}.cls-26{clip-path:url(#clippath-10);}.cls-27{clip-path:url(#clippath-42);}.cls-28{clip-path:url(#clippath-59);}.cls-29,.cls-30{fill:#fff;}.cls-31{clip-path:url(#clippath-43);}.cls-32{clip-path:url(#clippath-64);}.cls-33{clip-path:url(#clippath-25);}.cls-34{clip-path:url(#clippath-27);}.cls-35{clip-path:url(#clippath-60);}.cls-36{clip-path:url(#clippath-11);}.cls-37{clip-path:url(#clippath-57);}.cls-38{clip-path:url(#clippath-36);}.cls-11{stroke:#2b2e31;stroke-width:.7px;}.cls-39{fill:#2753a0;}.cls-40{clip-path:url(#clippath-35);}.cls-41{clip-path:url(#clippath-48);}.cls-42{clip-path:url(#clippath-28);}.cls-43{clip-path:url(#clippath-56);}.cls-44{clip-path:url(#clippath-45);}.cls-45{clip-path:url(#clippath-46);}.cls-46{clip-path:url(#clippath-40);}.cls-47{clip-path:url(#clippath-5);}.cls-48{clip-path:url(#clippath-20);}.cls-49{clip-path:url(#clippath-8);}.cls-50{clip-path:url(#clippath-52);}.cls-51{clip-path:url(#clippath-41);}.cls-52{clip-path:url(#clippath-67);}.cls-30{opacity:.6;}.cls-53{clip-path:url(#clippath-3);}.cls-54{clip-path:url(#clippath-26);}.cls-55{clip-path:url(#clippath-12);}.cls-56{clip-path:url(#clippath-50);}.cls-57{clip-path:url(#clippath-14);}.cls-58{clip-path:url(#clippath-30);}.cls-59{clip-path:url(#clippath-19);}.cls-60{clip-path:url(#clippath-32);}.cls-61{clip-path:url(#clippath-55);}.cls-62{clip-path:url(#clippath-53);}.cls-63{clip-path:url(#clippath-39);}.cls-64{clip-path:url(#clippath-16);}.cls-65{clip-path:url(#clippath-2);}.cls-66{clip-path:url(#clippath-29);}.cls-67{clip-path:url(#clippath-49);}.cls-68{clip-path:url(#clippath-37);}.cls-69{clip-path:url(#clippath-58);}.cls-70{clip-path:url(#clippath-13);}.cls-71{clip-path:url(#clippath-63);}.cls-72{clip-path:url(#clippath-24);}.cls-73{clip-path:url(#clippath);}.cls-74{clip-path:url(#clippath-68);}.cls-75{clip-path:url(#clippath-65);}.cls-76{clip-path:url(#clippath-44);}.cls-77{clip-path:url(#clippath-62);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-34"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-35"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-36"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-37"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-39"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-40"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-41"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-42"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-43"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-44"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-46"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-47"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-48"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-49"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-50"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-51"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-52"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-53"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-54"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-55"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-56"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-57"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-58"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-59"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-60"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-61"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-62"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-63"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-64"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-65"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-66"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-67"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-68"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0,
    y: 16.26,
    width: 456.38,
    height: 185.18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Element_1_copy1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0,
    y1: 125.01,
    x2: 367.84,
    y2: 125.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0,
    y1: 183.77,
    x2: 367.84,
    y2: 183.77
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0,
    y1: 154.39,
    x2: 367.84,
    y2: 154.39
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0,
    y1: 95.63,
    x2: 367.84,
    y2: 95.63
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0,
    y1: 66.25,
    x2: 367.84,
    y2: 66.25
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0,
    y1: 36.87,
    x2: 367.84,
    y2: 36.87
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 23.73,
    y: 125.01,
    width: 27.69,
    height: 17.63
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "79.1 61.85 106.79 61.85 106.79 125.01 79.1 125.01 79.1 61.85 79.1 61.85"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 142.39,
    y: 111.79,
    width: 27.69,
    height: 13.22
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "170.08 119.14 197.76 119.14 197.76 125.01 170.08 125.01 170.08 119.14 170.08 119.14"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 197.76,
    y: 125.01,
    width: 27.69,
    height: 16.16
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 261.05,
    y: 125.01,
    width: 27.69,
    height: 41.13
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "288.73 75.07 316.42 75.07 316.42 125.01 288.73 125.01 288.73 75.07 288.73 75.07"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 316.42,
    y: 31,
    width: 27.69,
    height: 94.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M.34,178.65v-.62h4.29v.62H.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M8.01,181.65v-1.76h-2.87v-.54l2.73-4.08h.92v3.96h.87v.66h-.87v1.76h-.78ZM6.01,179.23h2v-1.85c0-.17,0-.38.02-.61,0-.24.02-.44.03-.62h-.04c-.08.15-.16.3-.25.45-.09.15-.18.3-.27.45l-1.49,2.18Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M11.78,179.11c-.45,0-.81-.18-1.08-.54s-.4-.87-.4-1.54.13-1.17.4-1.52c.27-.36.63-.54,1.08-.54s.81.18,1.08.54c.27.36.41.87.41,1.52s-.14,1.18-.41,1.54-.63.54-1.08.54ZM11.78,178.6c.25,0,.46-.13.62-.4.16-.26.24-.66.24-1.18s-.08-.91-.24-1.17c-.16-.26-.37-.38-.62-.38s-.47.13-.63.38c-.16.26-.24.65-.24,1.17s.08.91.24,1.18c.16.26.37.4.63.4ZM11.96,181.77l3.62-6.8h.56l-3.62,6.8h-.56ZM16.35,181.77c-.45,0-.81-.18-1.08-.54s-.41-.87-.41-1.54.14-1.17.41-1.52c.27-.36.63-.54,1.08-.54s.81.18,1.08.54c.27.36.41.86.41,1.52s-.14,1.18-.41,1.54c-.27.36-.63.54-1.08.54ZM16.35,181.25c.25,0,.46-.13.62-.4.16-.26.24-.65.24-1.17s-.08-.91-.24-1.17c-.16-.26-.37-.38-.62-.38s-.47.13-.63.38c-.16.26-.24.65-.24,1.17s.08.91.24,1.17c.16.26.37.4.63.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M.34,149.27v-.62h4.29v.62H.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M5.37,152.27v-.49c.48-.48.91-.91,1.28-1.3.37-.39.69-.75.94-1.08.25-.33.45-.63.58-.91.13-.28.2-.54.2-.81,0-.37-.1-.67-.3-.9-.2-.23-.5-.35-.91-.35-.27,0-.51.08-.74.23-.23.15-.43.33-.62.54l-.47-.47c.27-.29.55-.53.85-.71s.66-.27,1.08-.27c.59,0,1.06.17,1.4.52s.51.8.51,1.36c0,.3-.07.6-.2.91s-.31.62-.54.94-.5.66-.82,1.01c-.32.35-.67.72-1.04,1.12.17-.01.35-.03.54-.04.19-.01.36-.02.53-.02h1.85v.71h-4.12Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M11.78,149.73c-.45,0-.81-.18-1.08-.54s-.4-.87-.4-1.54.13-1.17.4-1.52c.27-.36.63-.54,1.08-.54s.81.18,1.08.54c.27.36.41.87.41,1.52s-.14,1.18-.41,1.54-.63.54-1.08.54ZM11.78,149.22c.25,0,.46-.13.62-.4.16-.26.24-.66.24-1.18s-.08-.91-.24-1.17c-.16-.26-.37-.38-.62-.38s-.47.13-.63.38c-.16.26-.24.65-.24,1.17s.08.91.24,1.18c.16.26.37.4.63.4ZM11.96,152.39l3.62-6.8h.56l-3.62,6.8h-.56ZM16.35,152.39c-.45,0-.81-.18-1.08-.54s-.41-.87-.41-1.54.14-1.17.41-1.52c.27-.36.63-.54,1.08-.54s.81.18,1.08.54c.27.36.41.86.41,1.52s-.14,1.18-.41,1.54c-.27.36-.63.54-1.08.54ZM16.35,151.88c.25,0,.46-.13.62-.4.16-.26.24-.65.24-1.17s-.08-.91-.24-1.17c-.16-.26-.37-.38-.62-.38s-.47.13-.63.38c-.16.26-.24.65-.24,1.17s.08.91.24,1.17c.16.26.37.4.63.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M2.49,123.01c-.65,0-1.15-.29-1.51-.86-.36-.57-.54-1.4-.54-2.47s.18-1.89.54-2.45.86-.84,1.51-.84,1.14.28,1.5.84c.36.56.54,1.38.54,2.45s-.18,1.9-.54,2.47c-.36.57-.86.86-1.5.86ZM2.49,122.35c.19,0,.35-.05.5-.15.15-.1.28-.26.39-.48.11-.22.2-.49.26-.83.06-.34.09-.74.09-1.21s-.03-.87-.09-1.2c-.06-.33-.15-.6-.26-.81-.11-.21-.24-.36-.39-.46s-.32-.15-.5-.15-.36.05-.51.15-.29.25-.4.46-.19.48-.25.81c-.06.33-.09.73-.09,1.2,0,.93.11,1.61.34,2.04s.53.63.91.63Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M6.81,120.35c-.45,0-.81-.18-1.08-.54s-.4-.87-.4-1.54.13-1.17.4-1.52c.27-.36.63-.54,1.08-.54s.81.18,1.08.54c.27.36.41.87.41,1.52s-.14,1.18-.41,1.54-.63.54-1.08.54ZM6.81,119.84c.25,0,.46-.13.62-.4.16-.26.24-.66.24-1.18s-.08-.91-.24-1.17c-.16-.26-.37-.38-.62-.38s-.47.13-.63.38c-.16.26-.24.65-.24,1.17s.08.91.24,1.18c.16.26.37.4.63.4ZM6.99,123.01l3.62-6.8h.56l-3.62,6.8h-.56ZM11.38,123.01c-.45,0-.81-.18-1.08-.54s-.41-.87-.41-1.54.14-1.17.41-1.52c.27-.36.63-.54,1.08-.54s.81.18,1.08.54c.27.36.41.86.41,1.52s-.14,1.18-.41,1.54c-.27.36-.63.54-1.08.54ZM11.38,122.5c.25,0,.46-.13.62-.4.16-.26.24-.65.24-1.17s-.08-.91-.24-1.17c-.16-.26-.37-.38-.62-.38s-.47.13-.63.38c-.16.26-.24.65-.24,1.17s.08.91.24,1.17c.16.26.37.4.63.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M.4,93.51v-.49c.48-.48.91-.91,1.28-1.3.37-.39.69-.75.94-1.08.25-.33.45-.63.58-.91.13-.28.2-.54.2-.81,0-.37-.1-.67-.3-.9-.2-.23-.5-.35-.91-.35-.27,0-.51.08-.74.23-.23.15-.43.33-.62.54l-.47-.47c.27-.29.55-.53.85-.71s.66-.27,1.08-.27c.59,0,1.06.17,1.4.52s.51.8.51,1.36c0,.3-.07.6-.2.91s-.31.62-.54.94-.5.66-.82,1.01c-.32.35-.67.72-1.04,1.12.17-.01.35-.03.54-.04.19-.01.36-.02.53-.02h1.85v.71H.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M6.81,90.97c-.45,0-.81-.18-1.08-.54s-.4-.87-.4-1.54.13-1.17.4-1.52c.27-.36.63-.54,1.08-.54s.81.18,1.08.54c.27.36.41.87.41,1.52s-.14,1.18-.41,1.54-.63.54-1.08.54ZM6.81,90.46c.25,0,.46-.13.62-.4.16-.26.24-.66.24-1.18s-.08-.91-.24-1.17c-.16-.26-.37-.38-.62-.38s-.47.13-.63.38c-.16.26-.24.65-.24,1.17s.08.91.24,1.18c.16.26.37.4.63.4ZM6.99,93.63l3.62-6.8h.56l-3.62,6.8h-.56ZM11.38,93.63c-.45,0-.81-.18-1.08-.54s-.41-.87-.41-1.54.14-1.17.41-1.52c.27-.36.63-.54,1.08-.54s.81.18,1.08.54c.27.36.41.86.41,1.52s-.14,1.18-.41,1.54c-.27.36-.63.54-1.08.54ZM11.38,93.12c.25,0,.46-.13.62-.4.16-.26.24-.65.24-1.17s-.08-.91-.24-1.17c-.16-.26-.37-.38-.62-.38s-.47.13-.63.38c-.16.26-.24.65-.24,1.17s.08.91.24,1.17c.16.26.37.4.63.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M3.04,64.13v-1.76H.17v-.54l2.73-4.08h.92v3.96h.87v.66h-.87v1.76h-.78ZM1.04,61.71h2v-1.85c0-.17,0-.38.02-.61,0-.24.02-.44.03-.62h-.04c-.08.15-.16.3-.25.45-.09.15-.18.3-.27.45l-1.49,2.18Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M6.81,61.59c-.45,0-.81-.18-1.08-.54s-.4-.87-.4-1.54.13-1.17.4-1.52c.27-.36.63-.54,1.08-.54s.81.18,1.08.54c.27.36.41.87.41,1.52s-.14,1.18-.41,1.54-.63.54-1.08.54ZM6.81,61.08c.25,0,.46-.13.62-.4.16-.26.24-.66.24-1.18s-.08-.91-.24-1.17c-.16-.26-.37-.38-.62-.38s-.47.13-.63.38c-.16.26-.24.65-.24,1.17s.08.91.24,1.18c.16.26.37.4.63.4ZM6.99,64.25l3.62-6.8h.56l-3.62,6.8h-.56ZM11.38,64.25c-.45,0-.81-.18-1.08-.54s-.41-.87-.41-1.54.14-1.17.41-1.52c.27-.36.63-.54,1.08-.54s.81.18,1.08.54c.27.36.41.86.41,1.52s-.14,1.18-.41,1.54c-.27.36-.63.54-1.08.54ZM11.38,63.74c.25,0,.46-.13.62-.4.16-.26.24-.65.24-1.17s-.08-.91-.24-1.17c-.16-.26-.37-.38-.62-.38s-.47.13-.63.38c-.16.26-.24.65-.24,1.17s.08.91.24,1.17c.16.26.37.4.63.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M2.68,34.87c-.31,0-.6-.06-.87-.19-.27-.13-.5-.32-.69-.58-.2-.26-.35-.58-.47-.96s-.17-.83-.17-1.35c0-.64.07-1.18.2-1.63.13-.45.31-.82.54-1.1.23-.28.48-.49.77-.62.29-.13.59-.19.92-.19.35,0,.65.06.9.19.25.13.46.29.65.49l-.46.51c-.13-.15-.29-.27-.48-.36-.18-.09-.38-.14-.58-.14-.22,0-.43.05-.63.14-.2.09-.38.25-.53.46s-.28.49-.37.83c-.09.34-.14.77-.15,1.27.2-.25.43-.44.7-.58.27-.14.53-.21.79-.21.55,0,1,.16,1.33.49.33.33.49.82.49,1.48,0,.31-.05.58-.15.83s-.24.47-.41.65c-.17.18-.37.32-.6.42-.23.1-.47.15-.73.15ZM2.68,34.22c.16,0,.31-.03.44-.1.13-.07.25-.16.35-.29.1-.12.18-.27.23-.44s.08-.36.08-.58c0-.42-.1-.75-.29-.99-.19-.24-.49-.36-.89-.36-.21,0-.43.06-.67.19-.24.13-.46.34-.66.65.05.63.2,1.1.44,1.42.24.32.56.49.97.49Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M6.81,32.21c-.45,0-.81-.18-1.08-.54s-.4-.87-.4-1.54.13-1.17.4-1.52c.27-.36.63-.54,1.08-.54s.81.18,1.08.54c.27.36.41.87.41,1.52s-.14,1.18-.41,1.54-.63.54-1.08.54ZM6.81,31.7c.25,0,.46-.13.62-.4.16-.26.24-.66.24-1.18s-.08-.91-.24-1.17c-.16-.26-.37-.38-.62-.38s-.47.13-.63.38c-.16.26-.24.65-.24,1.17s.08.91.24,1.18c.16.26.37.4.63.4ZM6.99,34.87l3.62-6.8h.56l-3.62,6.8h-.56ZM11.38,34.87c-.45,0-.81-.18-1.08-.54s-.41-.87-.41-1.54.14-1.17.41-1.52c.27-.36.63-.54,1.08-.54s.81.18,1.08.54c.27.36.41.86.41,1.52s-.14,1.18-.41,1.54c-.27.36-.63.54-1.08.54ZM11.38,34.36c.25,0,.46-.13.62-.4.16-.26.24-.65.24-1.17s-.08-.91-.24-1.17c-.16-.26-.37-.38-.62-.38s-.47.13-.63.38c-.16.26-.24.65-.24,1.17s.08.91.24,1.17c.16.26.37.4.63.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 0,
    y1: 125.01,
    x2: 367.84,
    y2: 125.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M49.01,198.77v-.49c.48-.48.91-.91,1.28-1.3.37-.39.69-.75.94-1.07.25-.33.45-.63.58-.91.13-.28.2-.54.2-.81,0-.37-.1-.67-.3-.9-.2-.23-.5-.35-.91-.35-.27,0-.51.08-.74.23-.23.15-.43.33-.62.54l-.47-.47c.27-.29.55-.53.85-.71s.66-.27,1.08-.27c.59,0,1.06.17,1.4.52s.51.8.51,1.36c0,.3-.07.6-.2.91s-.31.62-.54.94c-.23.32-.5.66-.82,1.01-.32.35-.67.72-1.04,1.12.17-.01.35-.03.54-.04.19-.01.36-.02.53-.02h1.85v.71h-4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M56.07,198.89c-.65,0-1.15-.29-1.51-.86-.36-.57-.54-1.4-.54-2.47s.18-1.89.54-2.45.86-.84,1.51-.84,1.14.28,1.5.84c.36.56.54,1.38.54,2.45s-.18,1.9-.54,2.47c-.36.57-.86.86-1.5.86ZM56.07,198.23c.19,0,.35-.05.5-.15.15-.1.28-.26.39-.48.11-.22.2-.49.26-.83.06-.34.09-.74.09-1.2s-.03-.87-.09-1.2c-.06-.33-.15-.6-.26-.81-.11-.21-.24-.36-.39-.46s-.32-.15-.5-.15-.36.05-.51.15-.29.25-.4.46-.19.48-.25.81c-.06.33-.09.73-.09,1.2,0,.93.11,1.61.34,2.03s.53.63.91.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M59.34,198.77v-.68h1.46v-4.7h-1.16v-.53c.29-.05.55-.12.77-.19s.41-.17.58-.27h.63v5.7h1.32v.68h-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M66.01,198.89c-.65,0-1.15-.29-1.51-.86-.36-.57-.54-1.4-.54-2.47s.18-1.89.54-2.45.86-.84,1.51-.84,1.14.28,1.5.84c.36.56.54,1.38.54,2.45s-.18,1.9-.54,2.47c-.36.57-.86.86-1.5.86ZM66.01,198.23c.19,0,.35-.05.5-.15.15-.1.28-.26.39-.48.11-.22.2-.49.26-.83.06-.34.09-.74.09-1.2s-.03-.87-.09-1.2c-.06-.33-.15-.6-.26-.81-.11-.21-.24-.36-.39-.46s-.32-.15-.5-.15-.36.05-.51.15-.29.25-.4.46-.19.48-.25.81c-.06.33-.09.73-.09,1.2,0,.93.11,1.61.34,2.03s.53.63.91.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M68.9,196.58v-.63h2.3v.63h-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M72.39,198.77v-.68h1.46v-4.7h-1.16v-.53c.29-.05.55-.12.77-.19s.41-.17.58-.27h.63v5.7h1.32v.68h-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M79.61,198.77v-1.76h-2.87v-.54l2.73-4.08h.92v3.96h.87v.66h-.87v1.76h-.78ZM77.61,196.35h2v-1.85c0-.17,0-.38.02-.61,0-.24.02-.44.03-.62h-.04c-.08.15-.16.3-.25.45-.09.15-.18.3-.27.45l-1.49,2.18Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M167.67,198.77v-.49c.48-.48.91-.91,1.28-1.3.37-.39.69-.75.94-1.07.25-.33.45-.63.58-.91.13-.28.2-.54.2-.81,0-.37-.1-.67-.3-.9-.2-.23-.5-.35-.91-.35-.27,0-.51.08-.74.23-.23.15-.43.33-.62.54l-.47-.47c.27-.29.55-.53.85-.71s.66-.27,1.08-.27c.59,0,1.06.17,1.4.52s.51.8.51,1.36c0,.3-.07.6-.2.91s-.31.62-.54.94c-.23.32-.5.66-.82,1.01-.32.35-.67.72-1.04,1.12.17-.01.35-.03.54-.04.19-.01.36-.02.53-.02h1.85v.71h-4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M174.73,198.89c-.65,0-1.15-.29-1.51-.86-.36-.57-.54-1.4-.54-2.47s.18-1.89.54-2.45.86-.84,1.51-.84,1.14.28,1.5.84c.36.56.54,1.38.54,2.45s-.18,1.9-.54,2.47c-.36.57-.86.86-1.5.86ZM174.73,198.23c.19,0,.35-.05.5-.15.15-.1.28-.26.39-.48.11-.22.2-.49.26-.83.06-.34.09-.74.09-1.2s-.03-.87-.09-1.2c-.06-.33-.15-.6-.26-.81-.11-.21-.24-.36-.39-.46s-.32-.15-.5-.15-.36.05-.51.15-.29.25-.4.46-.19.48-.25.81c-.06.33-.09.73-.09,1.2,0,.93.11,1.61.34,2.03s.53.63.91.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M178,198.77v-.68h1.46v-4.7h-1.16v-.53c.29-.05.55-.12.77-.19s.41-.17.58-.27h.63v5.7h1.32v.68h-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M185.22,198.77v-1.76h-2.87v-.54l2.73-4.08h.92v3.96h.87v.66h-.87v1.76h-.78ZM183.22,196.35h2v-1.85c0-.17,0-.38.02-.61,0-.24.02-.44.03-.62h-.04c-.08.15-.16.3-.25.45-.09.15-.18.3-.27.45l-1.49,2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M187.56,196.58v-.63h2.3v.63h-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M190.66,198.77v-.49c.48-.48.91-.91,1.28-1.3.37-.39.69-.75.94-1.07.25-.33.45-.63.58-.91.13-.28.2-.54.2-.81,0-.37-.1-.67-.3-.9-.2-.23-.5-.35-.91-.35-.27,0-.51.08-.74.23-.23.15-.43.33-.62.54l-.47-.47c.27-.29.55-.53.85-.71s.66-.27,1.08-.27c.59,0,1.06.17,1.4.52s.51.8.51,1.36c0,.3-.07.6-.2.91s-.31.62-.54.94c-.23.32-.5.66-.82,1.01-.32.35-.67.72-1.04,1.12.17-.01.35-.03.54-.04.19-.01.36-.02.53-.02h1.85v.71h-4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M197.72,198.89c-.65,0-1.15-.29-1.51-.86-.36-.57-.54-1.4-.54-2.47s.18-1.89.54-2.45.86-.84,1.51-.84,1.14.28,1.5.84c.36.56.54,1.38.54,2.45s-.18,1.9-.54,2.47c-.36.57-.86.86-1.5.86ZM197.72,198.23c.19,0,.35-.05.5-.15.15-.1.28-.26.39-.48.11-.22.2-.49.26-.83.06-.34.09-.74.09-1.2s-.03-.87-.09-1.2c-.06-.33-.15-.6-.26-.81-.11-.21-.24-.36-.39-.46s-.32-.15-.5-.15-.36.05-.51.15-.29.25-.4.46-.19.48-.25.81c-.06.33-.09.73-.09,1.2,0,.93.11,1.61.34,2.03s.53.63.91.63Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M286.51,198.77v-.49c.48-.48.91-.91,1.28-1.3s.69-.75.94-1.07c.25-.33.45-.63.58-.91.13-.28.2-.54.2-.81,0-.37-.1-.67-.3-.9s-.5-.35-.91-.35c-.27,0-.51.08-.74.23-.23.15-.43.33-.62.54l-.47-.47c.27-.29.55-.53.85-.71s.66-.27,1.08-.27c.59,0,1.06.17,1.4.52s.51.8.51,1.36c0,.3-.07.6-.2.91s-.31.62-.54.94c-.23.32-.5.66-.82,1.01s-.67.72-1.04,1.12c.17-.01.35-.03.54-.04s.36-.02.53-.02h1.85v.71h-4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M293.57,198.89c-.65,0-1.15-.29-1.51-.86-.36-.57-.54-1.4-.54-2.47s.18-1.89.54-2.45c.36-.56.86-.84,1.51-.84s1.14.28,1.5.84c.36.56.54,1.38.54,2.45s-.18,1.9-.54,2.47c-.36.57-.86.86-1.5.86ZM293.57,198.23c.19,0,.35-.05.5-.15.15-.1.28-.26.39-.48.11-.22.2-.49.25-.83.06-.34.09-.74.09-1.2s-.03-.87-.09-1.2c-.06-.33-.14-.6-.25-.81s-.24-.36-.39-.46c-.15-.1-.32-.15-.5-.15s-.36.05-.51.15-.29.25-.39.46c-.11.21-.2.48-.25.81-.06.33-.09.73-.09,1.2,0,.93.11,1.61.34,2.03.23.42.53.63.91.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M296.45,198.77v-.49c.48-.48.91-.91,1.28-1.3.37-.39.69-.75.94-1.07s.45-.63.58-.91.2-.54.2-.81c0-.37-.1-.67-.3-.9-.2-.23-.5-.35-.91-.35-.27,0-.51.08-.74.23s-.43.33-.62.54l-.47-.47c.27-.29.55-.53.85-.71s.66-.27,1.08-.27c.59,0,1.06.17,1.4.52s.51.8.51,1.36c0,.3-.07.6-.2.91s-.31.62-.54.94c-.23.32-.5.66-.82,1.01-.32.35-.67.72-1.04,1.12.17-.01.35-.03.54-.04.19-.01.36-.02.53-.02h1.85v.71h-4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M303.51,198.89c-.65,0-1.15-.29-1.51-.86-.36-.57-.54-1.4-.54-2.47s.18-1.89.54-2.45c.36-.56.86-.84,1.51-.84s1.14.28,1.5.84.54,1.38.54,2.45-.18,1.9-.54,2.47c-.36.57-.86.86-1.5.86ZM303.51,198.23c.19,0,.36-.05.5-.15.15-.1.28-.26.39-.48.11-.22.2-.49.26-.83.06-.34.09-.74.09-1.2s-.03-.87-.09-1.2c-.06-.33-.15-.6-.26-.81-.11-.21-.24-.36-.39-.46-.15-.1-.32-.15-.5-.15s-.36.05-.51.15-.29.25-.4.46c-.11.21-.19.48-.25.81-.06.33-.09.73-.09,1.2,0,.93.12,1.61.34,2.03.23.42.53.63.91.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M306.4,196.58v-.63h2.3v.63h-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M309.5,198.77v-.49c.48-.48.91-.91,1.28-1.3.37-.39.69-.75.94-1.07s.45-.63.58-.91.2-.54.2-.81c0-.37-.1-.67-.3-.9-.2-.23-.5-.35-.91-.35-.27,0-.51.08-.74.23s-.43.33-.62.54l-.47-.47c.27-.29.55-.53.85-.71s.66-.27,1.08-.27c.59,0,1.06.17,1.4.52s.51.8.51,1.36c0,.3-.07.6-.2.91s-.31.62-.54.94c-.23.32-.5.66-.82,1.01-.32.35-.67.72-1.04,1.12.17-.01.35-.03.54-.04.19-.01.36-.02.53-.02h1.85v.71h-4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M316.43,198.89c-.25,0-.49-.02-.7-.08-.21-.05-.4-.12-.58-.2-.17-.08-.33-.18-.46-.29s-.26-.22-.37-.34l.42-.54c.19.2.42.38.67.53.26.15.58.23.96.23s.7-.1.95-.31c.25-.21.37-.5.37-.85,0-.19-.03-.36-.1-.52-.07-.16-.19-.29-.34-.4-.16-.11-.37-.2-.63-.26-.26-.06-.58-.09-.96-.09v-.63c.34,0,.62-.03.86-.09.23-.06.42-.14.56-.25.14-.11.25-.23.31-.38.06-.15.09-.3.09-.47,0-.31-.1-.56-.29-.74-.2-.18-.46-.27-.81-.27-.27,0-.51.06-.73.18-.22.12-.43.28-.62.47l-.44-.52c.25-.23.52-.42.82-.57.3-.15.63-.23,1.01-.23.28,0,.54.04.77.11.23.07.43.18.6.31.17.14.3.31.4.51.09.2.14.43.14.69,0,.39-.11.7-.32.95-.21.25-.49.44-.84.57v.04c.19.05.37.11.54.2.17.09.31.2.44.34.13.14.22.29.29.47.07.18.1.38.1.6,0,.28-.05.53-.17.76-.11.23-.26.42-.45.57-.19.16-.41.28-.67.36-.25.08-.53.12-.82.12Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "23.68 144.34 23.68 144.34 51.47 144.34 51.47 157.37 23.68 157.37 23.68 144.34"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M25.4,151.36v-.94h4.14v.94h-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M30.48,153.86v-1.07h1.24v-3.3h-1.07v-.82c.31-.06.58-.13.79-.22.22-.08.43-.19.63-.31h.97v4.64h1.07v1.07h-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M35.28,155.6l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M37.63,153.86v-.76c.37-.34.7-.66,1-.96.3-.3.56-.58.78-.84.22-.26.39-.5.51-.73.12-.23.18-.44.18-.64,0-.28-.07-.5-.22-.64s-.34-.22-.59-.22c-.21,0-.4.06-.56.18-.16.12-.32.25-.46.41l-.72-.71c.28-.3.57-.53.86-.68.29-.15.65-.23,1.05-.23.28,0,.54.04.77.13s.43.21.6.37c.17.16.3.35.39.57.09.22.14.47.14.75,0,.24-.05.48-.15.73s-.24.5-.41.75c-.17.25-.37.5-.58.75-.22.25-.45.49-.68.73.14-.02.3-.03.48-.05.18-.02.33-.02.47-.02h1.15v1.12h-4.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M43.74,151.61c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36s.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.36.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM43.74,150.87c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88c.1.17.23.25.38.25ZM43.94,153.97l3.17-6.08h.77l-3.17,6.08h-.76ZM48.07,153.97c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM48.07,153.23c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "142.34 97.06 142.34 97.06 170.13 97.06 170.13 110.09 142.34 110.09 142.34 97.06"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M145.64,105.73v-1.66h-1.58v-.94h1.58v-1.66h.97v1.66h1.58v.94h-1.58v1.66h-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M150.88,106.68c-.31,0-.58-.06-.84-.19s-.47-.32-.64-.57c-.18-.25-.31-.56-.41-.94s-.15-.8-.15-1.29.05-.91.15-1.28c.1-.37.24-.67.41-.92.18-.25.39-.44.64-.56.25-.12.53-.18.84-.18s.58.06.84.18c.25.12.47.31.64.56s.31.56.41.92c.1.37.15.79.15,1.28s-.05.92-.15,1.29-.24.68-.41.94c-.18.25-.39.44-.64.57s-.53.19-.84.19ZM150.88,105.65c.11,0,.22-.03.31-.09s.18-.16.25-.31c.07-.15.13-.35.17-.6s.06-.57.06-.96-.02-.71-.06-.96-.09-.44-.17-.58c-.07-.14-.16-.24-.25-.29-.1-.05-.2-.08-.31-.08-.11,0-.21.03-.31.08-.1.05-.18.15-.25.29-.07.14-.13.34-.17.58s-.06.57-.06.96.02.71.06.96.1.45.17.6c.07.15.16.25.25.31.1.06.2.09.31.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M153.94,108.32l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M158.02,106.68c-.38,0-.71-.07-.99-.21-.28-.14-.51-.3-.69-.48l.7-.79c.1.11.23.2.39.28s.33.12.5.12.31-.03.45-.09c.14-.06.26-.16.36-.3s.19-.32.25-.55c.06-.23.1-.51.11-.84-.07.1-.16.18-.25.26-.1.07-.19.14-.3.19-.1.05-.2.09-.31.12-.1.03-.2.04-.29.04-.25,0-.47-.04-.68-.11s-.39-.18-.54-.32c-.15-.14-.27-.33-.36-.55-.09-.22-.13-.48-.13-.78s.05-.56.15-.8c.1-.24.24-.44.41-.61.17-.17.37-.3.6-.38.23-.09.48-.13.73-.13.28,0,.54.05.81.16.26.11.49.28.69.5.2.23.36.52.49.88s.18.79.18,1.29c0,.53-.06,1-.19,1.39-.13.39-.3.71-.51.96s-.46.44-.74.56c-.28.12-.57.18-.87.18ZM158.23,103.49c.15,0,.3-.04.45-.13.15-.09.29-.23.4-.44-.06-.45-.17-.76-.34-.93-.17-.17-.35-.26-.55-.26-.19,0-.36.07-.5.22s-.22.38-.22.71c0,.31.07.52.22.64.14.12.32.18.54.18Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M162.4,104.32c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36s.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.36.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM162.4,103.58c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88c.1.17.23.25.38.25ZM162.6,106.68l3.17-6.08h.77l-3.17,6.08h-.76ZM166.73,106.68c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM166.73,105.94c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "260.99 167.84 260.99 167.84 288.79 167.84 288.79 180.88 260.99 180.88 260.99 167.84"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M262.72,174.86v-.94h4.14v.94h-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M267.49,177.36v-.76c.37-.34.7-.66,1-.96.3-.3.56-.58.78-.84.22-.26.39-.5.51-.73.12-.23.18-.44.18-.64,0-.28-.07-.5-.22-.64-.14-.15-.34-.22-.59-.22-.21,0-.4.06-.56.18-.16.12-.32.25-.46.41l-.72-.71c.28-.3.57-.53.86-.68.29-.15.65-.23,1.05-.23.28,0,.54.04.77.13.23.09.43.21.6.37.17.16.3.35.39.57s.13.47.13.75c0,.24-.05.48-.15.73-.1.25-.24.5-.41.75s-.37.5-.58.75-.45.49-.68.73c.14-.02.3-.03.48-.05.18-.02.33-.02.47-.02h1.15v1.12h-4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M272.6,179.11l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M276.98,177.47c-.29,0-.55-.04-.8-.11-.24-.08-.45-.18-.63-.32-.18-.14-.31-.3-.41-.49-.1-.19-.15-.41-.15-.64,0-.35.09-.63.28-.85.19-.22.42-.4.69-.55v-.04c-.22-.17-.41-.36-.55-.57-.14-.21-.22-.47-.22-.78,0-.24.04-.46.14-.65.09-.19.22-.36.38-.5.16-.14.36-.24.58-.31.22-.07.47-.11.73-.11s.5.04.71.11.4.18.55.31c.15.13.27.3.35.5s.13.41.13.64c0,.28-.08.52-.23.73-.15.21-.32.39-.52.52v.04c.28.15.51.34.7.58.19.23.29.54.29.92,0,.23-.05.44-.14.63-.1.19-.23.36-.41.5-.18.14-.39.25-.64.33-.25.08-.53.12-.83.12ZM277.01,176.55c.22,0,.4-.06.55-.18.14-.12.22-.3.22-.54,0-.13-.03-.23-.08-.32-.06-.09-.14-.17-.25-.25-.11-.08-.24-.15-.38-.21-.15-.07-.31-.14-.49-.22-.13.12-.23.26-.31.41-.08.16-.13.32-.13.5,0,.25.09.45.26.59s.38.21.62.21ZM277.34,174.03c.23-.27.35-.55.35-.84,0-.22-.06-.4-.18-.54-.12-.13-.29-.2-.51-.2-.17,0-.32.05-.45.16-.13.11-.19.27-.19.5,0,.23.09.42.27.55.18.13.42.26.71.37Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M281.06,175.11c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.41.04.58.13.33.21.46.36c.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM281.06,174.37c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.11.17.23.25.38.25ZM281.26,177.47l3.17-6.08h.76l-3.17,6.08h-.76ZM285.39,177.47c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36c.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM285.39,176.73c.15,0,.28-.08.38-.25.11-.17.16-.46.16-.88s-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "51.36 110.28 51.36 110.28 79.16 110.28 79.16 123.31 51.36 123.31 51.36 110.28"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M54.67,118.95v-1.66h-1.58v-.94h1.58v-1.66h.97v1.66h1.58v.94h-1.58v1.66h-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M59.91,119.9c-.31,0-.58-.06-.84-.19s-.47-.32-.64-.57c-.18-.25-.31-.56-.41-.94s-.15-.8-.15-1.29.05-.91.15-1.28c.1-.37.24-.67.41-.92.18-.25.39-.44.64-.56.25-.12.53-.18.84-.18s.58.06.84.18c.25.12.47.31.64.56s.31.56.41.92c.1.37.15.79.15,1.28s-.05.92-.15,1.29-.24.68-.41.94c-.18.25-.39.44-.64.57s-.53.19-.84.19ZM59.91,118.88c.11,0,.22-.03.31-.09s.18-.16.25-.31c.07-.15.13-.35.17-.6s.06-.57.06-.96-.02-.71-.06-.96-.09-.44-.17-.58c-.07-.14-.16-.24-.25-.29-.1-.05-.2-.08-.31-.08-.11,0-.21.03-.31.08-.1.05-.18.15-.25.29-.07.14-.13.34-.17.58s-.06.57-.06.96.02.71.06.96.1.45.17.6c.07.15.16.25.25.31.1.06.2.09.31.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M62.97,121.54l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M67.36,119.9c-.31,0-.58-.06-.84-.19s-.47-.32-.64-.57c-.18-.25-.31-.56-.41-.94s-.15-.8-.15-1.29.05-.91.15-1.28c.1-.37.24-.67.41-.92.18-.25.39-.44.64-.56.25-.12.53-.18.84-.18s.58.06.84.18c.25.12.47.31.64.56s.31.56.41.92c.1.37.15.79.15,1.28s-.05.92-.15,1.29-.24.68-.41.94c-.18.25-.39.44-.64.57s-.53.19-.84.19ZM67.36,118.88c.11,0,.22-.03.31-.09s.18-.16.25-.31c.07-.15.13-.35.17-.6s.06-.57.06-.96-.02-.71-.06-.96-.09-.44-.17-.58c-.07-.14-.16-.24-.25-.29-.1-.05-.2-.08-.31-.08-.11,0-.21.03-.31.08-.1.05-.18.15-.25.29-.07.14-.13.34-.17.58s-.06.57-.06.96.02.71.06.96.1.45.17.6c.07.15.16.25.25.31.1.06.2.09.31.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M71.43,117.54c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36s.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.36.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM71.43,116.81c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88c.1.17.23.25.38.25ZM71.63,119.9l3.17-6.08h.77l-3.17,6.08h-.76ZM75.76,119.9c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM75.76,119.16c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "170.02 104.4 170.02 104.4 197.81 104.4 197.81 117.43 170.02 117.43 170.02 104.4"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M173.33,113.07v-1.66h-1.58v-.94h1.58v-1.66h.97v1.66h1.58v.94h-1.58v1.66h-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M178.57,114.03c-.31,0-.58-.06-.84-.19s-.47-.32-.64-.57c-.18-.25-.31-.56-.41-.94s-.15-.8-.15-1.29.05-.91.15-1.28c.1-.37.24-.67.41-.92.18-.25.39-.44.64-.56.25-.12.53-.18.84-.18s.58.06.84.18c.25.12.47.31.64.56s.31.56.41.92c.1.37.15.79.15,1.28s-.05.92-.15,1.29-.24.68-.41.94c-.18.25-.39.44-.64.57s-.53.19-.84.19ZM178.57,113c.11,0,.22-.03.31-.09s.18-.16.25-.31c.07-.15.13-.35.17-.6s.06-.57.06-.96-.02-.71-.06-.96-.09-.44-.17-.58c-.07-.14-.16-.24-.25-.29-.1-.05-.2-.08-.31-.08-.11,0-.21.03-.31.08-.1.05-.18.15-.25.29-.07.14-.13.34-.17.58s-.06.57-.06.96.02.71.06.96.1.45.17.6c.07.15.16.25.25.31.1.06.2.09.31.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M181.63,115.66l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M186.29,113.92v-1.37h-2.48v-.91l2.09-3.44h1.62v3.34h.66v1.01h-.66v1.37h-1.23ZM185.08,111.54h1.21v-.93c0-.19,0-.4.02-.64.01-.24.02-.45.04-.63h-.04c-.07.16-.15.31-.23.48s-.16.32-.24.49l-.76,1.24Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M190.09,111.67c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36s.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.36.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM190.09,110.93c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88c.1.17.23.25.38.25ZM190.29,114.03l3.17-6.08h.77l-3.17,6.08h-.76ZM194.42,114.03c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM194.42,113.29c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "288.68 60.33 288.68 60.33 316.47 60.33 316.47 73.37 288.68 73.37 288.68 60.33"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M291.99,69v-1.66h-1.58v-.94h1.58v-1.66h.97v1.66h1.58v.94h-1.58v1.66h-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M297.04,69.96c-.47,0-.86-.07-1.19-.22s-.59-.34-.8-.59l.61-.84c.17.17.36.31.57.41s.43.16.68.16c.28,0,.51-.06.67-.18.17-.12.25-.28.25-.5,0-.13-.02-.24-.07-.34s-.12-.19-.24-.26c-.11-.07-.27-.12-.47-.16-.2-.04-.45-.06-.76-.06v-.94c.26,0,.47-.02.64-.05.17-.04.31-.09.41-.16.1-.07.18-.15.22-.24.04-.09.07-.2.07-.31,0-.2-.06-.35-.18-.46-.12-.11-.29-.17-.52-.17-.2,0-.39.04-.55.14-.17.09-.34.21-.52.37l-.67-.81c.26-.23.54-.41.83-.54s.61-.19.97-.19c.29,0,.56.03.81.1.24.07.45.17.62.31.17.14.3.3.4.49s.14.41.14.67c0,.3-.08.55-.25.76s-.4.38-.71.51v.04c.33.1.6.26.82.49.21.23.32.53.32.9,0,.26-.06.5-.17.71-.11.21-.27.38-.46.52-.19.14-.42.25-.68.32-.26.07-.53.11-.82.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M300.28,71.59l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M304.95,69.85v-1.37h-2.48v-.91l2.09-3.44h1.62v3.34h.66v1.01h-.66v1.37h-1.23ZM303.74,67.47h1.21v-.93c0-.19,0-.4.02-.64.01-.24.02-.45.04-.63h-.04c-.07.16-.15.31-.22.48s-.16.32-.24.49l-.76,1.24Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M308.74,67.6c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.41.04.58.13.33.21.46.36c.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM308.74,66.86c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.11.17.23.25.38.25ZM308.94,69.96l3.17-6.08h.76l-3.17,6.08h-.76ZM313.07,69.96c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36c.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM313.07,69.22c.15,0,.28-.08.38-.25.11-.17.16-.46.16-.88s-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "79.05 47.11 79.05 47.11 106.84 47.11 106.84 60.14 79.05 60.14 79.05 47.11"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M82.36,55.78v-1.66h-1.58v-.94h1.58v-1.66h.97v1.66h1.58v.94h-1.58v1.66h-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M87.87,56.63v-1.37h-2.48v-.91l2.09-3.44h1.62v3.34h.66v1.01h-.66v1.37h-1.23ZM86.66,54.25h1.21v-.93c0-.19,0-.4.02-.64.01-.24.02-.45.04-.63h-.04c-.07.16-.15.31-.23.48s-.16.32-.24.49l-.76,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M90.66,58.37l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M94.86,56.73c-.47,0-.86-.07-1.19-.22s-.59-.34-.8-.59l.61-.84c.17.17.36.31.57.41s.43.16.68.16c.28,0,.51-.06.67-.18.17-.12.25-.28.25-.5,0-.13-.02-.24-.07-.34s-.12-.19-.24-.26c-.11-.07-.27-.12-.47-.16-.2-.04-.45-.06-.76-.06v-.94c.26,0,.47-.02.64-.05.17-.04.31-.09.41-.16s.18-.15.23-.24c.04-.09.07-.2.07-.31,0-.2-.06-.35-.18-.46-.12-.11-.29-.17-.52-.17-.2,0-.39.04-.55.14-.17.09-.34.21-.52.37l-.67-.81c.26-.23.54-.41.83-.54s.61-.19.97-.19c.29,0,.56.03.81.1.24.07.45.17.62.31.17.14.3.3.4.49.1.19.14.41.14.67,0,.3-.08.55-.25.76s-.4.38-.71.51v.04c.33.1.6.26.81.49.21.23.32.53.32.9,0,.26-.06.5-.17.71-.11.21-.27.38-.46.52-.19.14-.42.25-.68.32-.26.07-.53.11-.82.11Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M99.12,54.38c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36s.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.36.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM99.12,53.64c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88c.1.17.23.25.38.25ZM99.31,56.73l3.17-6.08h.77l-3.17,6.08h-.76ZM103.45,56.73c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM103.45,56c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "197.71 142.87 197.71 142.87 225.5 142.87 225.5 155.91 197.71 155.91 197.71 142.87"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M199.43,149.89v-.94h4.14v.94h-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M204.51,152.39v-1.07h1.24v-3.3h-1.07v-.82c.31-.06.58-.13.79-.22.22-.08.43-.19.63-.31h.97v4.64h1.07v1.07h-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M209.31,154.13l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M211.96,152.39v-1.07h1.24v-3.3h-1.07v-.82c.31-.06.58-.13.79-.22.22-.08.43-.19.63-.31h.97v4.64h1.07v1.07h-3.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M217.77,150.14c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36s.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.36.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM217.77,149.4c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88c.1.17.23.25.38.25ZM217.97,152.5l3.17-6.08h.77l-3.17,6.08h-.76ZM222.1,152.5c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM222.1,151.76c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "316.37 16.26 316.37 16.26 344.16 16.26 344.16 29.3 316.37 29.3 316.37 16.26"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M319.67,24.93v-1.66h-1.58v-.94h1.58v-1.66h.97v1.66h1.58v.94h-1.58v1.66h-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M325.06,25.89c-.28,0-.54-.05-.8-.16-.26-.11-.49-.28-.69-.5s-.36-.52-.48-.88-.18-.79-.18-1.29c0-.53.06-1,.19-1.39.13-.39.3-.71.51-.96s.46-.44.74-.56c.28-.12.57-.18.87-.18.38,0,.71.07.98.2.28.14.5.3.68.48l-.69.79c-.1-.11-.23-.2-.4-.28s-.33-.12-.5-.12c-.16,0-.3.03-.44.09-.14.06-.26.16-.36.3-.1.14-.19.33-.26.55-.07.23-.11.51-.12.84.07-.1.16-.18.25-.26.1-.07.19-.14.3-.19s.2-.09.31-.12c.1-.03.2-.04.29-.04.25,0,.47.04.68.11.21.07.39.18.54.32s.27.33.36.55c.08.22.13.48.13.78s-.05.57-.15.8c-.1.23-.24.44-.41.6s-.37.3-.6.38c-.23.09-.48.13-.73.13ZM325.04,24.9c.2,0,.37-.07.51-.22.14-.15.21-.38.21-.71,0-.31-.07-.52-.21-.64-.14-.12-.32-.18-.54-.18-.15,0-.3.04-.45.13-.15.09-.29.23-.41.44.03.23.08.42.14.57.06.15.13.27.21.36.08.09.16.16.26.2s.19.06.29.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M327.97,27.52l-.27-.7c.34-.12.59-.28.76-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.58-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28s-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M332.63,25.78v-1.37h-2.47v-.91l2.09-3.44h1.62v3.34h.66v1.01h-.66v1.37h-1.23ZM331.43,23.4h1.21v-.93c0-.19,0-.4.02-.64.01-.24.02-.45.04-.63h-.04c-.07.16-.15.31-.23.48s-.16.32-.24.49l-.76,1.24Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-69"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M336.43,23.53c-.21,0-.4-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59-.11-.49-.11-.79.04-.55.11-.78.17-.42.3-.58c.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.41.04.58.13c.18.08.33.21.46.36.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59-.28.29-.46.37c-.18.08-.38.13-.58.13ZM336.43,22.79c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.11.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25ZM336.63,25.89l3.17-6.08h.77l-3.17,6.08h-.76ZM340.76,25.89c-.21,0-.4-.04-.58-.13-.18-.08-.33-.21-.46-.37-.13-.16-.23-.36-.3-.59s-.11-.49-.11-.79.04-.55.11-.78.17-.42.3-.58c.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.41.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM340.76,25.15c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.11.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 368.5,
    y: 16.26,
    width: 88.13,
    height: 71.39
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 374.17,
    y: 18.89,
    width: 8.5,
    height: 8.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M388.44,24.93v-5.58h.71v2.34h2.59v-2.34h.71v5.58h-.71v-2.63h-2.59v2.63h-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M395.52,25.03c-.26,0-.5-.05-.73-.14s-.43-.24-.61-.42c-.18-.18-.32-.41-.42-.68s-.16-.57-.16-.91.05-.65.16-.92c.1-.27.25-.5.42-.68s.38-.33.61-.42.47-.14.73-.14.5.05.73.14.43.24.61.42.32.42.42.68c.1.27.16.58.16.92s-.05.65-.16.91c-.11.27-.25.5-.42.68-.18.18-.38.32-.61.42s-.47.14-.73.14ZM395.52,24.45c.17,0,.34-.04.48-.11.15-.08.27-.18.38-.32.1-.14.19-.3.24-.5.06-.19.08-.41.08-.65s-.03-.45-.08-.65c-.06-.2-.14-.36-.24-.51s-.23-.25-.38-.33c-.15-.08-.31-.11-.48-.11s-.34.04-.49.11c-.15.08-.27.19-.38.33s-.19.31-.24.51c-.06.2-.08.41-.08.65s.03.45.08.65c.06.19.14.36.24.5.1.14.23.25.38.32s.31.11.49.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M399.73,25.03c-.44,0-.76-.14-.96-.41s-.3-.67-.3-1.21v-2.62h.71v2.52c0,.39.06.67.18.85.12.17.32.26.59.26.21,0,.4-.06.57-.17.16-.11.35-.29.54-.53v-2.93h.7v4.13h-.58l-.06-.65h-.03c-.19.23-.4.41-.61.54-.21.14-.46.2-.75.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M404.23,25.03c-.29,0-.58-.05-.84-.16-.27-.11-.5-.24-.7-.41l.35-.47c.18.15.37.27.56.36.19.09.41.14.66.14.27,0,.48-.06.61-.19s.2-.28.2-.46c0-.11-.03-.2-.08-.28-.06-.08-.13-.15-.22-.21s-.19-.11-.3-.16l-.34-.14c-.15-.05-.29-.11-.44-.17-.15-.06-.28-.14-.39-.24-.12-.09-.21-.2-.29-.33s-.11-.27-.11-.45c0-.16.03-.32.1-.46s.16-.27.28-.37c.12-.1.27-.19.45-.25.18-.06.37-.09.59-.09.26,0,.5.05.72.14.22.09.41.2.57.33l-.33.44c-.14-.11-.29-.2-.44-.26-.15-.07-.32-.1-.5-.1-.26,0-.45.06-.57.18-.12.12-.18.26-.18.42,0,.1.03.18.08.25s.12.13.2.19.18.1.29.14.23.09.34.13c.15.06.3.12.45.18.15.06.29.14.4.23.12.09.22.21.29.34.08.14.12.3.12.49,0,.17-.03.33-.1.48-.07.15-.16.28-.29.39-.13.11-.29.2-.48.27-.19.06-.41.1-.65.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M408.38,25.03c-.28,0-.54-.05-.78-.15-.24-.1-.45-.24-.63-.42-.18-.18-.32-.41-.42-.68-.1-.27-.15-.57-.15-.91s.05-.64.16-.91.24-.5.42-.68.37-.33.59-.43c.22-.1.45-.15.69-.15.26,0,.49.05.7.14.21.09.38.22.52.39.14.17.25.37.32.61.07.24.11.5.11.8,0,.07,0,.15,0,.22s0,.13-.02.18h-2.79c.03.44.17.79.41,1.05.25.26.57.39.96.39.2,0,.38-.03.55-.09.17-.06.33-.14.48-.23l.25.46c-.18.11-.38.21-.6.3s-.47.13-.76.13ZM407.08,22.53h2.21c0-.42-.09-.74-.27-.96-.18-.22-.43-.33-.75-.33-.15,0-.29.03-.42.08-.13.06-.25.14-.36.25s-.2.25-.27.4-.12.34-.14.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M410.92,24.93v-6.05h.7v1.65l-.03.85c.2-.19.4-.35.62-.48.21-.13.47-.2.76-.2.44,0,.75.14.96.41s.3.67.3,1.21v2.62h-.7v-2.52c0-.39-.06-.67-.19-.85-.12-.17-.32-.26-.6-.26-.21,0-.41.05-.57.16-.16.11-.35.27-.56.48v2.99h-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M417.15,25.03c-.26,0-.5-.05-.73-.14s-.43-.24-.61-.42c-.18-.18-.32-.41-.42-.68s-.16-.57-.16-.91.05-.65.16-.92c.1-.27.25-.5.42-.68s.38-.33.61-.42.47-.14.73-.14.5.05.73.14.43.24.61.42.32.42.42.68c.1.27.16.58.16.92s-.05.65-.16.91c-.11.27-.25.5-.42.68-.18.18-.38.32-.61.42s-.47.14-.73.14ZM417.15,24.45c.17,0,.34-.04.48-.11.15-.08.27-.18.38-.32.1-.14.19-.3.24-.5.06-.19.08-.41.08-.65s-.03-.45-.08-.65c-.06-.2-.14-.36-.24-.51s-.23-.25-.38-.33c-.15-.08-.31-.11-.48-.11s-.34.04-.49.11c-.15.08-.27.19-.38.33s-.19.31-.24.51c-.06.2-.08.41-.08.65s.03.45.08.65c.06.19.14.36.24.5.1.14.23.25.38.32s.31.11.49.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M420.89,25.03c-.27,0-.46-.08-.57-.24-.11-.16-.17-.39-.17-.7v-5.22h.7v5.27c0,.11.02.19.06.24.04.05.08.07.14.07h.06s.05,0,.09-.02l.09.53s-.1.04-.16.05-.14.02-.24.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M423.73,25.03c-.52,0-.94-.19-1.25-.56s-.46-.91-.46-1.6c0-.33.05-.64.15-.91.1-.27.23-.5.4-.68s.35-.33.57-.43.44-.15.68-.15.45.04.62.13.35.2.54.35l-.03-.71v-1.59h.71v6.05h-.58l-.06-.48h-.03c-.17.16-.35.3-.57.41s-.44.17-.68.17ZM423.89,24.44c.19,0,.37-.05.54-.14.17-.09.34-.24.51-.43v-2.16c-.18-.16-.34-.27-.51-.34-.16-.06-.33-.1-.5-.1s-.32.04-.46.11-.27.18-.38.32c-.11.14-.19.3-.26.5-.06.19-.09.41-.09.65,0,.5.1.89.3,1.16s.48.42.84.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M428.12,25.03c-.29,0-.58-.05-.84-.16s-.5-.24-.7-.41l.35-.47c.18.15.37.27.56.36.19.09.41.14.66.14.27,0,.48-.06.61-.19.14-.12.2-.28.2-.46,0-.11-.03-.2-.08-.28-.06-.08-.13-.15-.22-.21-.09-.06-.19-.11-.3-.16-.11-.05-.23-.09-.34-.14-.15-.05-.29-.11-.44-.17-.15-.06-.28-.14-.4-.24-.12-.09-.21-.2-.28-.33-.07-.12-.11-.27-.11-.45,0-.16.03-.32.1-.46.07-.14.16-.27.28-.37.12-.1.27-.19.45-.25.17-.06.37-.09.59-.09.26,0,.5.05.72.14.22.09.41.2.57.33l-.33.44c-.14-.11-.29-.2-.44-.26s-.32-.1-.5-.1c-.26,0-.45.06-.57.18-.12.12-.18.26-.18.42,0,.1.03.18.08.25.05.07.12.13.2.19s.18.1.29.14c.11.04.23.09.34.13.15.06.3.12.45.18.15.06.29.14.4.23.12.09.22.21.29.34.08.14.11.3.11.49,0,.17-.03.33-.1.48s-.16.28-.29.39c-.13.11-.29.2-.48.27-.19.06-.41.1-.65.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M433.98,25.03c-.28,0-.54-.05-.78-.15-.24-.1-.45-.24-.63-.42s-.32-.41-.42-.68c-.1-.27-.15-.57-.15-.91s.05-.64.16-.91c.1-.27.24-.5.42-.68s.37-.33.59-.43c.22-.1.45-.15.69-.15.26,0,.49.05.7.14.21.09.38.22.52.39s.25.37.32.61c.07.24.11.5.11.8,0,.07,0,.15,0,.22s0,.13-.02.18h-2.79c.03.44.17.79.41,1.05.25.26.57.39.96.39.2,0,.38-.03.55-.09s.33-.14.48-.23l.25.46c-.18.11-.38.21-.6.3-.22.08-.47.13-.76.13ZM432.68,22.53h2.21c0-.42-.09-.74-.27-.96-.18-.22-.43-.33-.75-.33-.15,0-.29.03-.42.08-.13.06-.25.14-.36.25-.11.11-.2.25-.27.4-.07.16-.12.34-.14.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M436.52,24.93v-4.13h.58l.06.59h.03c.2-.2.41-.36.62-.5.22-.13.47-.2.76-.2.44,0,.75.14.96.41s.3.67.3,1.21v2.62h-.7v-2.52c0-.39-.06-.67-.19-.85-.12-.17-.32-.26-.6-.26-.21,0-.41.05-.57.16-.16.11-.35.27-.56.48v2.99h-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M442.84,25.03c-.28,0-.54-.05-.78-.15-.24-.1-.45-.24-.63-.42s-.32-.41-.42-.68c-.1-.27-.15-.57-.15-.91s.05-.64.16-.91c.1-.27.24-.5.42-.68s.37-.33.59-.43c.22-.1.45-.15.69-.15.26,0,.49.05.7.14.21.09.38.22.52.39s.25.37.32.61c.07.24.11.5.11.8,0,.07,0,.15,0,.22s0,.13-.02.18h-2.79c.03.44.17.79.41,1.05.25.26.57.39.96.39.2,0,.38-.03.55-.09s.33-.14.48-.23l.25.46c-.18.11-.38.21-.6.3-.22.08-.47.13-.76.13ZM441.54,22.53h2.21c0-.42-.09-.74-.27-.96-.18-.22-.43-.33-.75-.33-.15,0-.29.03-.42.08-.13.06-.25.14-.36.25-.11.11-.2.25-.27.4-.07.16-.12.34-.14.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M445.38,24.93v-4.13h.58l.06.75h.03c.14-.26.31-.47.51-.62.2-.15.42-.23.66-.23.16,0,.31.03.44.08l-.14.61c-.07-.02-.13-.04-.19-.05s-.13-.02-.21-.02c-.18,0-.36.07-.55.21-.19.14-.36.39-.5.74v2.65h-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M449.73,26.83c-.25,0-.49-.02-.7-.07-.21-.05-.39-.12-.54-.22-.15-.1-.27-.21-.35-.35-.08-.14-.12-.29-.12-.48s.05-.34.16-.5.25-.3.44-.43v-.03c-.1-.06-.19-.15-.26-.26-.07-.11-.11-.25-.11-.41,0-.18.05-.33.14-.46s.2-.23.31-.31v-.03c-.14-.11-.26-.27-.37-.45-.11-.19-.17-.41-.17-.66,0-.23.04-.43.12-.61.08-.18.19-.34.34-.46s.31-.23.5-.29c.19-.07.39-.1.6-.1.11,0,.22,0,.32.03.1.02.19.04.27.07h1.44v.54h-.85c.1.1.18.22.24.37s.1.31.1.48c0,.22-.04.42-.12.6-.08.18-.19.33-.32.45-.14.12-.3.22-.48.28-.18.07-.38.1-.59.1-.1,0-.21-.01-.31-.04s-.21-.06-.31-.11c-.07.06-.14.13-.19.21-.05.08-.08.17-.08.28,0,.13.05.24.15.32.1.08.29.13.58.13h.8c.48,0,.84.08,1.08.23.24.16.36.41.36.75,0,.19-.05.38-.14.55s-.24.32-.42.45c-.18.13-.4.23-.66.31-.26.08-.55.11-.87.11ZM449.83,26.35c.2,0,.38-.02.54-.07s.3-.11.41-.19c.11-.08.2-.17.26-.27s.09-.21.09-.31c0-.19-.07-.33-.21-.4-.14-.07-.35-.11-.62-.11h-.71c-.08,0-.17,0-.26-.01-.09,0-.19-.03-.28-.06-.15.11-.25.22-.32.34-.07.12-.1.24-.1.36,0,.22.11.4.32.53.21.13.5.2.88.2ZM449.73,23.15c.12,0,.23-.02.34-.07.1-.04.2-.11.28-.2s.15-.19.19-.31c.04-.12.07-.26.07-.41,0-.31-.08-.54-.25-.71s-.38-.25-.62-.25-.45.08-.62.25c-.17.17-.26.4-.26.71,0,.15.02.29.07.41.04.12.11.23.19.31s.18.15.28.2c.1.05.22.07.34.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M452.68,26.7c-.1,0-.18,0-.26-.02-.08-.01-.15-.04-.22-.06l.14-.55.15.04c.06.01.11.02.16.02.24,0,.43-.08.58-.25s.27-.38.35-.63l.09-.31-1.66-4.14h.72l.84,2.29c.06.18.13.37.2.57.07.2.14.4.2.59h.03c.06-.19.12-.38.18-.59s.11-.4.17-.58l.74-2.29h.68l-1.56,4.47c-.07.2-.16.39-.25.57-.09.18-.2.33-.32.45-.12.13-.27.23-.43.3-.16.07-.34.11-.55.11Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-77"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M390.01,34.38c-.27,0-.53-.05-.77-.14-.24-.1-.44-.24-.62-.42-.17-.18-.31-.41-.41-.68-.1-.27-.15-.57-.15-.91s.05-.65.16-.92c.11-.27.25-.5.43-.68.18-.19.39-.33.63-.42.24-.1.49-.14.76-.14s.5.05.7.14c.19.1.36.21.51.34l-.36.46c-.12-.11-.25-.2-.38-.26-.13-.07-.28-.1-.45-.1-.19,0-.36.04-.52.11-.16.08-.29.19-.41.33s-.2.31-.27.51c-.07.2-.1.41-.1.65s.03.45.09.65c.06.19.15.36.26.5.11.14.25.25.4.32.16.08.33.11.52.11s.37-.04.53-.12c.16-.08.31-.18.44-.29l.31.47c-.19.16-.39.29-.62.39-.23.09-.46.14-.71.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M393.86,34.38c-.26,0-.5-.05-.73-.14s-.43-.24-.61-.42c-.18-.18-.32-.41-.42-.68s-.16-.57-.16-.91.05-.65.16-.92c.1-.27.25-.5.42-.68s.38-.33.61-.42.47-.14.73-.14.5.05.73.14.43.24.61.42.32.42.42.68c.1.27.16.58.16.92s-.05.65-.16.91c-.11.27-.25.5-.42.68-.18.18-.38.32-.61.42s-.47.14-.73.14ZM393.86,33.8c.17,0,.34-.04.48-.11.15-.08.27-.18.38-.32.1-.14.19-.3.24-.5.06-.19.08-.41.08-.65s-.03-.45-.08-.65c-.06-.2-.14-.36-.24-.51s-.23-.25-.38-.33c-.15-.08-.31-.11-.48-.11s-.34.04-.49.11c-.15.08-.27.19-.38.33s-.19.31-.24.51c-.06.2-.08.41-.08.65s.03.45.08.65c.06.19.14.36.24.5.1.14.23.25.38.32s.31.11.49.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M396.86,34.28v-4.13h.58l.06.59h.03c.2-.2.41-.36.62-.5.22-.13.47-.2.76-.2.44,0,.75.14.96.41s.3.67.3,1.21v2.62h-.7v-2.52c0-.39-.06-.67-.19-.85-.12-.17-.32-.26-.6-.26-.21,0-.41.05-.57.16-.16.11-.35.27-.56.48v2.99h-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M402.59,34.38c-.29,0-.58-.05-.84-.16-.27-.11-.5-.24-.7-.41l.35-.47c.18.15.37.27.56.36.19.09.41.14.66.14.27,0,.48-.06.61-.19s.2-.28.2-.46c0-.11-.03-.2-.08-.28-.06-.08-.13-.15-.22-.21s-.19-.11-.3-.16l-.34-.14c-.15-.05-.29-.11-.44-.17-.15-.06-.28-.14-.39-.24-.12-.09-.21-.2-.29-.33s-.11-.27-.11-.45c0-.16.03-.32.1-.46s.16-.27.28-.37c.12-.1.27-.19.45-.25.18-.06.37-.09.59-.09.26,0,.5.05.72.14.22.09.41.2.57.33l-.33.44c-.14-.11-.29-.2-.44-.26-.15-.07-.32-.1-.5-.1-.26,0-.45.06-.57.18-.12.12-.18.26-.18.42,0,.1.03.18.08.25s.12.13.2.19.18.1.29.14.23.09.34.13c.15.06.3.12.45.18.15.06.29.14.4.23.12.09.22.21.29.34.08.14.12.3.12.49,0,.17-.03.33-.1.48-.07.15-.16.28-.29.39-.13.11-.29.2-.48.27-.19.06-.41.1-.65.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M406.27,34.38c-.44,0-.76-.14-.96-.41s-.3-.67-.3-1.21v-2.62h.71v2.52c0,.39.06.67.18.85.12.17.32.26.59.26.21,0,.4-.06.57-.17.16-.11.35-.29.54-.53v-2.93h.7v4.13h-.58l-.06-.65h-.03c-.19.23-.4.41-.61.54-.21.14-.46.2-.75.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M409.69,34.28v-4.13h.58l.06.59h.03c.18-.2.38-.36.59-.5.21-.13.44-.2.69-.2.32,0,.57.07.74.21.18.14.31.33.4.58.21-.24.43-.43.65-.57.22-.14.46-.22.71-.22.42,0,.74.14.95.41.21.27.31.67.31,1.21v2.62h-.7v-2.52c0-.39-.06-.67-.19-.85s-.32-.26-.58-.26c-.31,0-.66.21-1.04.64v2.99h-.7v-2.52c0-.39-.06-.67-.19-.85s-.32-.26-.59-.26c-.31,0-.66.21-1.04.64v2.99h-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M416.74,36.02v-5.87h.58l.06.48h.03c.19-.16.39-.29.62-.41.22-.11.46-.17.7-.17.27,0,.5.05.71.15.2.1.37.24.51.43s.24.41.31.66c.07.26.11.55.11.87,0,.35-.05.66-.14.94-.1.27-.23.51-.39.7-.16.19-.35.34-.57.44-.21.1-.44.15-.68.15-.19,0-.38-.04-.57-.13-.19-.08-.38-.2-.57-.35l.02.72v1.39h-.7ZM418.45,33.79c.17,0,.33-.04.47-.11.14-.08.27-.18.37-.32.1-.14.19-.31.25-.51.06-.2.09-.43.09-.69,0-.23-.02-.43-.06-.62-.04-.19-.1-.35-.19-.48-.09-.13-.2-.24-.34-.31-.14-.07-.3-.11-.5-.11-.18,0-.35.05-.53.14s-.37.24-.57.42v2.17c.19.16.37.27.54.34.18.06.33.1.47.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M422.76,34.38c-.22,0-.41-.03-.56-.1-.15-.07-.27-.16-.37-.28-.09-.12-.16-.26-.2-.43-.04-.17-.06-.36-.06-.56v-2.29h-.61v-.53l.65-.04.08-1.16h.59v1.16h1.11v.57h-1.11v2.29c0,.25.05.45.14.59.09.14.26.21.5.21.07,0,.15-.01.24-.03s.16-.05.23-.08l.14.53c-.11.04-.24.07-.37.11-.13.03-.26.05-.39.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M424.69,29.3c-.14,0-.25-.04-.34-.13s-.14-.19-.14-.32.05-.25.14-.33.21-.12.34-.12.25.04.34.12.14.19.14.33-.05.24-.14.32-.21.13-.34.13ZM424.33,34.28v-4.13h.7v4.13h-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M428.03,34.38c-.25,0-.5-.05-.73-.14s-.43-.24-.61-.42c-.18-.18-.32-.41-.42-.68-.11-.27-.16-.57-.16-.91s.05-.65.16-.92c.1-.27.25-.5.42-.68.17-.19.38-.33.61-.42s.47-.14.73-.14.5.05.73.14.43.24.61.42c.17.19.32.42.42.68.11.27.16.58.16.92s-.05.65-.16.91c-.1.27-.25.5-.42.68-.18.18-.38.32-.61.42s-.47.14-.73.14ZM428.03,33.8c.18,0,.34-.04.48-.11s.27-.18.38-.32c.11-.14.19-.3.24-.5.06-.19.08-.41.08-.65s-.03-.45-.08-.65c-.06-.2-.14-.36-.24-.51-.1-.14-.23-.25-.38-.33-.15-.08-.31-.11-.48-.11s-.34.04-.48.11c-.15.08-.27.19-.38.33-.11.14-.19.31-.24.51-.06.2-.09.41-.09.65s.03.45.09.65c.06.19.14.36.24.5.1.14.23.25.38.32s.31.11.48.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M431.03,34.28v-4.13h.58l.06.59h.03c.2-.2.41-.36.62-.5s.47-.2.76-.2c.44,0,.75.14.96.41s.3.67.3,1.21v2.62h-.7v-2.52c0-.39-.06-.67-.19-.85s-.32-.26-.59-.26c-.22,0-.41.05-.57.16-.17.11-.35.27-.56.48v2.99h-.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 374.17,
    y: 44.58,
    width: 8.5,
    height: 8.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M388.44,50.61v-5.58h1.59c.31,0,.6.03.85.08.26.06.48.15.66.28s.32.3.42.51c.1.21.15.47.15.77s-.05.55-.15.77c-.1.22-.24.39-.42.54-.18.14-.4.25-.65.32-.25.07-.53.11-.84.11h-.92v2.21h-.71ZM389.15,47.83h.83c.49,0,.85-.09,1.08-.28.24-.18.35-.47.35-.87s-.12-.68-.37-.84c-.25-.16-.61-.23-1.1-.23h-.8v2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M393.19,50.61v-4.13h.58l.06.75h.03c.14-.26.31-.47.51-.62.2-.15.42-.23.66-.23.16,0,.31.03.44.08l-.14.61c-.07-.02-.13-.04-.19-.05s-.13-.02-.21-.02c-.18,0-.36.07-.55.21-.19.14-.36.39-.5.74v2.65h-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M396.49,45.63c-.14,0-.25-.04-.34-.13s-.14-.19-.14-.32.05-.25.14-.33.21-.12.34-.12.25.04.34.12.14.19.14.33-.05.24-.14.32-.21.13-.34.13ZM396.13,50.61v-4.13h.7v4.13h-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M399.12,50.61l-1.49-4.13h.72l.78,2.35c.06.2.13.41.19.61.07.2.13.41.19.6h.03c.06-.2.12-.4.19-.6l.19-.61.78-2.35h.69l-1.46,4.13h-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M403.15,50.72c-.35,0-.63-.1-.86-.31s-.34-.49-.34-.87c0-.45.2-.8.6-1.04.4-.24,1.04-.41,1.93-.51,0-.13-.01-.26-.04-.38-.03-.12-.07-.23-.13-.33-.06-.1-.15-.17-.26-.23s-.25-.09-.42-.09c-.24,0-.46.05-.67.14-.21.09-.4.19-.56.31l-.27-.48c.19-.12.43-.25.71-.36s.58-.17.92-.17c.5,0,.87.15,1.1.46.23.31.34.72.34,1.24v2.53h-.58l-.06-.49h-.03c-.2.16-.41.3-.64.42s-.47.17-.73.17ZM403.35,50.15c.2,0,.38-.05.56-.14.18-.09.36-.23.56-.41v-1.15c-.35.05-.64.1-.87.16-.23.06-.42.14-.57.22s-.25.18-.31.29c-.07.11-.1.23-.1.36,0,.24.07.41.21.51s.31.15.52.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M407.78,50.72c-.22,0-.41-.03-.56-.1s-.27-.16-.37-.28c-.09-.12-.16-.26-.2-.43-.04-.17-.06-.36-.06-.56v-2.29h-.61v-.53l.65-.04.08-1.16h.59v1.16h1.11v.57h-1.11v2.29c0,.25.05.45.14.59.09.14.26.21.5.21.07,0,.15-.01.24-.03s.16-.05.23-.08l.14.53c-.11.04-.24.07-.37.11s-.26.05-.4.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M411.03,50.72c-.28,0-.54-.05-.78-.15-.24-.1-.45-.24-.63-.42-.18-.18-.32-.41-.42-.68-.1-.27-.15-.57-.15-.91s.05-.64.16-.91.24-.5.42-.68.37-.33.59-.43c.22-.1.45-.15.69-.15.26,0,.49.05.7.14.21.09.38.22.52.39.14.17.25.37.32.61.07.24.11.5.11.8,0,.07,0,.15,0,.22s0,.13-.02.18h-2.79c.03.44.17.79.41,1.05.25.26.57.39.96.39.2,0,.38-.03.55-.09.17-.06.33-.14.48-.23l.25.46c-.18.11-.38.21-.6.3s-.47.13-.76.13ZM409.73,48.22h2.21c0-.42-.09-.74-.27-.96-.18-.22-.43-.33-.75-.33-.15,0-.29.03-.42.08-.13.06-.25.14-.36.25s-.2.25-.27.4-.12.34-.14.54Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-75"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M390.01,60.07c-.27,0-.53-.05-.77-.14-.24-.1-.44-.24-.62-.42-.17-.18-.31-.41-.41-.68-.1-.27-.15-.57-.15-.91s.05-.65.16-.92c.11-.27.25-.5.43-.68.18-.19.39-.33.63-.42.24-.1.49-.14.76-.14s.5.05.7.14c.19.1.36.21.51.34l-.36.46c-.12-.11-.25-.2-.38-.26-.13-.07-.28-.1-.45-.1-.19,0-.36.04-.52.11-.16.08-.29.19-.41.33s-.2.31-.27.51c-.07.2-.1.41-.1.65s.03.45.09.65c.06.19.15.36.26.5.11.14.25.25.4.32.16.08.33.11.52.11s.37-.04.53-.12c.16-.08.31-.18.44-.29l.31.47c-.19.16-.39.29-.62.39-.23.09-.46.14-.71.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M393.86,60.07c-.26,0-.5-.05-.73-.14s-.43-.24-.61-.42c-.18-.18-.32-.41-.42-.68s-.16-.57-.16-.91.05-.65.16-.92c.1-.27.25-.5.42-.68s.38-.33.61-.42.47-.14.73-.14.5.05.73.14.43.24.61.42.32.42.42.68c.1.27.16.58.16.92s-.05.65-.16.91c-.11.27-.25.5-.42.68-.18.18-.38.32-.61.42s-.47.14-.73.14ZM393.86,59.49c.17,0,.34-.04.48-.11.15-.08.27-.18.38-.32.1-.14.19-.3.24-.5.06-.19.08-.41.08-.65s-.03-.45-.08-.65c-.06-.2-.14-.36-.24-.51s-.23-.25-.38-.33c-.15-.08-.31-.11-.48-.11s-.34.04-.49.11c-.15.08-.27.19-.38.33s-.19.31-.24.51c-.06.2-.08.41-.08.65s.03.45.08.65c.06.19.14.36.24.5.1.14.23.25.38.32s.31.11.49.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M396.86,59.96v-4.13h.58l.06.59h.03c.2-.2.41-.36.62-.5.22-.13.47-.2.76-.2.44,0,.75.14.96.41s.3.67.3,1.21v2.62h-.7v-2.52c0-.39-.06-.67-.19-.85-.12-.17-.32-.26-.6-.26-.21,0-.41.05-.57.16-.16.11-.35.27-.56.48v2.99h-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M402.59,60.07c-.29,0-.58-.05-.84-.16-.27-.11-.5-.24-.7-.41l.35-.47c.18.15.37.27.56.36.19.09.41.14.66.14.27,0,.48-.06.61-.19s.2-.28.2-.46c0-.11-.03-.2-.08-.28-.06-.08-.13-.15-.22-.21s-.19-.11-.3-.16l-.34-.14c-.15-.05-.29-.11-.44-.17-.15-.06-.28-.14-.39-.24-.12-.09-.21-.2-.29-.33s-.11-.27-.11-.45c0-.16.03-.32.1-.46s.16-.27.28-.37c.12-.1.27-.19.45-.25.18-.06.37-.09.59-.09.26,0,.5.05.72.14.22.09.41.2.57.33l-.33.44c-.14-.11-.29-.2-.44-.26-.15-.07-.32-.1-.5-.1-.26,0-.45.06-.57.18-.12.12-.18.26-.18.42,0,.1.03.18.08.25s.12.13.2.19.18.1.29.14.23.09.34.13c.15.06.3.12.45.18.15.06.29.14.4.23.12.09.22.21.29.34.08.14.12.3.12.49,0,.17-.03.33-.1.48-.07.15-.16.28-.29.39-.13.11-.29.2-.48.27-.19.06-.41.1-.65.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M406.27,60.07c-.44,0-.76-.14-.96-.41s-.3-.67-.3-1.21v-2.62h.71v2.52c0,.39.06.67.18.85.12.17.32.26.59.26.21,0,.4-.06.57-.17.16-.11.35-.29.54-.53v-2.93h.7v4.13h-.58l-.06-.65h-.03c-.19.23-.4.41-.61.54-.21.14-.46.2-.75.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M409.69,59.96v-4.13h.58l.06.59h.03c.18-.2.38-.36.59-.5.21-.13.44-.2.69-.2.32,0,.57.07.74.21.18.14.31.33.4.58.21-.24.43-.43.65-.57.22-.14.46-.22.71-.22.42,0,.74.14.95.41.21.27.31.67.31,1.21v2.62h-.7v-2.52c0-.39-.06-.67-.19-.85s-.32-.26-.58-.26c-.31,0-.66.21-1.04.64v2.99h-.7v-2.52c0-.39-.06-.67-.19-.85s-.32-.26-.59-.26c-.31,0-.66.21-1.04.64v2.99h-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M416.74,61.71v-5.87h.58l.06.48h.03c.19-.16.39-.29.62-.41.22-.11.46-.17.7-.17.27,0,.5.05.71.15.2.1.37.24.51.43s.24.41.31.66c.07.26.11.55.11.87,0,.35-.05.66-.14.94-.1.27-.23.51-.39.7-.16.19-.35.34-.57.44-.21.1-.44.15-.68.15-.19,0-.38-.04-.57-.13-.19-.08-.38-.2-.57-.35l.02.72v1.39h-.7ZM418.45,59.48c.17,0,.33-.04.47-.11.14-.08.27-.18.37-.32.1-.14.19-.31.25-.51.06-.2.09-.43.09-.69,0-.23-.02-.43-.06-.62-.04-.19-.1-.35-.19-.48-.09-.13-.2-.24-.34-.31-.14-.07-.3-.11-.5-.11-.18,0-.35.05-.53.14s-.37.24-.57.42v2.17c.19.16.37.27.54.34.18.06.33.1.47.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M422.76,60.07c-.22,0-.41-.03-.56-.1-.15-.07-.27-.16-.37-.28-.09-.12-.16-.26-.2-.43-.04-.17-.06-.36-.06-.56v-2.29h-.61v-.53l.65-.04.08-1.16h.59v1.16h1.11v.57h-1.11v2.29c0,.25.05.45.14.59.09.14.26.21.5.21.07,0,.15-.01.24-.03s.16-.05.23-.08l.14.53c-.11.04-.24.07-.37.11-.13.03-.26.05-.39.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M424.69,54.98c-.14,0-.25-.04-.34-.13s-.14-.19-.14-.32.05-.25.14-.33.21-.12.34-.12.25.04.34.12.14.19.14.33-.05.24-.14.32-.21.13-.34.13ZM424.33,59.96v-4.13h.7v4.13h-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M428.03,60.07c-.25,0-.5-.05-.73-.14s-.43-.24-.61-.42c-.18-.18-.32-.41-.42-.68-.11-.27-.16-.57-.16-.91s.05-.65.16-.92c.1-.27.25-.5.42-.68.17-.19.38-.33.61-.42s.47-.14.73-.14.5.05.73.14.43.24.61.42c.17.19.32.42.42.68.11.27.16.58.16.92s-.05.65-.16.91c-.1.27-.25.5-.42.68-.18.18-.38.32-.61.42s-.47.14-.73.14ZM428.03,59.49c.18,0,.34-.04.48-.11s.27-.18.38-.32c.11-.14.19-.3.24-.5.06-.19.08-.41.08-.65s-.03-.45-.08-.65c-.06-.2-.14-.36-.24-.51-.1-.14-.23-.25-.38-.33-.15-.08-.31-.11-.48-.11s-.34.04-.48.11c-.15.08-.27.19-.38.33-.11.14-.19.31-.24.51-.06.2-.09.41-.09.65s.03.45.09.65c.06.19.14.36.24.5.1.14.23.25.38.32s.31.11.48.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M431.03,59.96v-4.13h.58l.06.59h.03c.2-.2.41-.36.62-.5s.47-.2.76-.2c.44,0,.75.14.96.41s.3.67.3,1.21v2.62h-.7v-2.52c0-.39-.06-.67-.19-.85s-.32-.26-.59-.26c-.22,0-.41.05-.57.16-.17.11-.35.27-.56.48v2.99h-.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 374.17,
    y: 70.26,
    width: 8.5,
    height: 8.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M387.7,76.3l1.89-5.58h.8l1.89,5.58h-.76l-.53-1.7h-2.03l-.54,1.7h-.72ZM389.4,73.18l-.26.85h1.67l-.26-.85c-.1-.31-.2-.62-.29-.93-.09-.31-.18-.62-.27-.95h-.03c-.08.32-.17.64-.26.95-.09.31-.19.62-.29.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M393.89,76.3l-1.49-4.13h.72l.78,2.35c.06.2.13.41.19.61.06.2.13.41.19.6h.03c.06-.2.12-.4.19-.6.06-.2.12-.41.19-.61l.78-2.35h.69l-1.46,4.13h-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M398.64,76.4c-.28,0-.54-.05-.78-.15-.24-.1-.45-.24-.63-.42s-.32-.41-.42-.68c-.1-.27-.15-.57-.15-.91s.05-.64.16-.91c.1-.27.24-.5.42-.68s.37-.33.59-.43c.22-.1.45-.15.69-.15.26,0,.49.05.7.14.21.09.38.22.52.39s.25.37.32.61c.07.24.11.5.11.8,0,.07,0,.15,0,.22s0,.13-.02.18h-2.79c.03.44.17.79.41,1.05.25.26.57.39.96.39.2,0,.38-.03.55-.09s.33-.14.48-.23l.25.46c-.18.11-.38.21-.6.3-.22.08-.47.13-.76.13ZM397.34,73.9h2.21c0-.42-.09-.74-.27-.96-.18-.22-.43-.33-.75-.33-.15,0-.29.03-.42.08-.13.06-.25.14-.36.25-.11.11-.2.25-.27.4-.07.16-.12.34-.14.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M401.18,76.3v-4.13h.58l.06.75h.03c.14-.26.31-.47.51-.62.2-.15.42-.23.66-.23.16,0,.31.03.44.08l-.14.61c-.07-.02-.13-.04-.19-.05s-.13-.02-.21-.02c-.18,0-.36.07-.55.21-.19.14-.36.39-.5.74v2.65h-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M405.08,76.4c-.35,0-.63-.1-.86-.31s-.34-.49-.34-.87c0-.45.2-.8.6-1.04.4-.24,1.05-.41,1.93-.51,0-.13-.01-.26-.04-.38s-.07-.23-.13-.33c-.06-.1-.15-.17-.26-.23-.11-.06-.25-.09-.42-.09-.24,0-.46.05-.67.14-.21.09-.4.19-.56.31l-.27-.48c.19-.12.43-.25.71-.36.28-.12.58-.17.92-.17.5,0,.87.15,1.1.46.23.31.34.72.34,1.24v2.53h-.58l-.06-.49h-.03c-.2.16-.41.3-.64.42s-.47.17-.73.17ZM405.29,75.84c.2,0,.39-.05.56-.14.17-.09.36-.23.56-.41v-1.15c-.35.05-.64.1-.87.16-.24.06-.42.14-.57.22s-.25.18-.31.29c-.07.11-.1.23-.1.36,0,.24.07.41.21.51s.31.15.52.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M409.81,78.2c-.25,0-.49-.02-.7-.07-.21-.05-.39-.12-.54-.22-.15-.1-.27-.21-.35-.35-.08-.14-.12-.29-.12-.48s.05-.34.16-.5.25-.3.44-.43v-.03c-.1-.06-.19-.15-.26-.26-.07-.11-.11-.25-.11-.41,0-.18.05-.33.14-.46.1-.13.2-.23.31-.31v-.03c-.14-.11-.26-.27-.37-.45-.11-.19-.17-.41-.17-.66,0-.23.04-.43.12-.61.08-.18.19-.34.34-.46s.31-.23.5-.29c.19-.07.39-.1.6-.1.11,0,.22,0,.32.03.1.02.19.04.27.07h1.44v.54h-.85c.1.1.18.22.24.37.06.15.1.31.1.48,0,.22-.04.42-.12.6-.08.18-.19.33-.32.45-.14.12-.3.22-.48.28-.18.07-.38.1-.59.1-.1,0-.21-.01-.31-.04-.11-.03-.21-.06-.31-.11-.07.06-.14.13-.19.21-.05.08-.08.17-.08.28,0,.13.05.24.15.32.1.08.29.13.58.13h.8c.48,0,.84.08,1.08.23.24.16.36.41.36.75,0,.19-.05.38-.14.55-.1.17-.24.32-.42.45s-.4.23-.66.31c-.26.08-.55.11-.87.11ZM409.91,77.72c.2,0,.38-.02.54-.07.16-.05.3-.11.41-.19.11-.08.2-.17.26-.27.06-.1.09-.21.09-.31,0-.19-.07-.33-.21-.4-.14-.07-.35-.11-.62-.11h-.71c-.08,0-.17,0-.26-.01-.09,0-.19-.03-.28-.06-.15.11-.25.22-.32.34-.07.12-.1.24-.1.36,0,.22.11.4.32.53s.51.2.88.2ZM409.81,74.52c.12,0,.23-.02.34-.07.11-.04.2-.11.28-.2.08-.08.15-.19.19-.31.05-.12.07-.26.07-.41,0-.31-.08-.54-.25-.71s-.38-.25-.62-.25-.45.08-.62.25-.25.4-.25.71c0,.15.02.29.07.41.04.12.11.23.19.31s.18.15.28.2c.1.05.22.07.33.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M414.38,76.4c-.28,0-.54-.05-.78-.15-.24-.1-.45-.24-.63-.42s-.32-.41-.42-.68c-.1-.27-.15-.57-.15-.91s.05-.64.16-.91c.1-.27.24-.5.42-.68s.37-.33.59-.43c.22-.1.45-.15.69-.15.26,0,.49.05.7.14.21.09.38.22.52.39s.25.37.32.61c.07.24.11.5.11.8,0,.07,0,.15,0,.22s0,.13-.02.18h-2.79c.03.44.17.79.41,1.05.25.26.57.39.96.39.2,0,.38-.03.55-.09s.33-.14.48-.23l.25.46c-.18.11-.38.21-.6.3-.22.08-.47.13-.76.13ZM413.07,73.9h2.21c0-.42-.09-.74-.27-.96-.18-.22-.43-.33-.75-.33-.15,0-.29.03-.42.08-.13.06-.25.14-.36.25-.11.11-.2.25-.27.4-.07.16-.12.34-.14.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M420.29,76.4c-.28,0-.54-.05-.78-.15-.24-.1-.45-.24-.63-.42-.18-.18-.32-.41-.42-.68-.1-.27-.15-.57-.15-.91s.05-.64.16-.91.24-.5.42-.68.37-.33.59-.43c.22-.1.45-.15.69-.15.26,0,.49.05.7.14.21.09.38.22.52.39.14.17.25.37.32.61.07.24.11.5.11.8,0,.07,0,.15,0,.22s0,.13-.02.18h-2.79c.03.44.17.79.41,1.05.25.26.57.39.96.39.2,0,.38-.03.55-.09.17-.06.33-.14.48-.23l.25.46c-.18.11-.38.21-.6.3s-.47.13-.76.13ZM418.99,73.9h2.21c0-.42-.09-.74-.27-.96-.18-.22-.43-.33-.75-.33-.15,0-.29.03-.42.08-.13.06-.25.14-.36.25s-.2.25-.27.4-.12.34-.14.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M422.83,76.3v-4.13h.58l.06.59h.03c.2-.2.41-.36.62-.5.22-.13.47-.2.76-.2.44,0,.75.14.96.41s.3.67.3,1.21v2.62h-.7v-2.52c0-.39-.06-.67-.19-.85-.12-.17-.32-.26-.6-.26-.21,0-.41.05-.57.16-.16.11-.35.27-.56.48v2.99h-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M429.16,76.4c-.28,0-.54-.05-.78-.15-.24-.1-.45-.24-.63-.42s-.32-.41-.42-.68c-.1-.27-.15-.57-.15-.91s.05-.64.16-.91c.1-.27.24-.5.42-.68s.37-.33.59-.43c.22-.1.45-.15.69-.15.26,0,.49.05.7.14.21.09.38.22.52.39s.25.37.32.61c.07.24.11.5.11.8,0,.07,0,.15,0,.22s0,.13-.02.18h-2.79c.03.44.17.79.41,1.05.25.26.57.39.96.39.2,0,.38-.03.55-.09s.33-.14.48-.23l.25.46c-.18.11-.38.21-.6.3-.22.08-.47.13-.76.13ZM427.86,73.9h2.21c0-.42-.09-.74-.27-.96-.18-.22-.43-.33-.75-.33-.15,0-.29.03-.42.08-.13.06-.25.14-.36.25-.11.11-.2.25-.27.4-.07.16-.12.34-.14.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M431.7,76.3v-4.13h.58l.06.75h.03c.14-.26.31-.47.51-.62.2-.15.42-.23.66-.23.16,0,.31.03.44.08l-.14.61c-.07-.02-.13-.04-.19-.05s-.13-.02-.21-.02c-.18,0-.36.07-.55.21-.19.14-.36.39-.5.74v2.65h-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M436.04,78.2c-.25,0-.49-.02-.7-.07-.21-.05-.39-.12-.54-.22-.15-.1-.27-.21-.35-.35-.08-.14-.12-.29-.12-.48s.05-.34.16-.5.25-.3.44-.43v-.03c-.1-.06-.19-.15-.26-.26-.07-.11-.11-.25-.11-.41,0-.18.05-.33.14-.46.1-.13.2-.23.31-.31v-.03c-.14-.11-.26-.27-.37-.45-.11-.19-.17-.41-.17-.66,0-.23.04-.43.12-.61.08-.18.19-.34.34-.46s.31-.23.5-.29c.19-.07.39-.1.6-.1.11,0,.22,0,.32.03.1.02.19.04.27.07h1.44v.54h-.85c.1.1.18.22.24.37.06.15.1.31.1.48,0,.22-.04.42-.12.6-.08.18-.19.33-.32.45-.14.12-.3.22-.48.28-.18.07-.38.1-.59.1-.1,0-.21-.01-.31-.04-.11-.03-.21-.06-.31-.11-.07.06-.14.13-.19.21-.05.08-.08.17-.08.28,0,.13.05.24.15.32.1.08.29.13.58.13h.8c.48,0,.84.08,1.08.23.24.16.36.41.36.75,0,.19-.05.38-.14.55-.1.17-.24.32-.42.45s-.4.23-.66.31c-.26.08-.55.11-.87.11ZM436.14,77.72c.2,0,.38-.02.54-.07.16-.05.3-.11.41-.19.11-.08.2-.17.26-.27.06-.1.09-.21.09-.31,0-.19-.07-.33-.21-.4-.14-.07-.35-.11-.62-.11h-.71c-.08,0-.17,0-.26-.01-.09,0-.19-.03-.28-.06-.15.11-.25.22-.32.34-.07.12-.1.24-.1.36,0,.22.11.4.32.53s.51.2.88.2ZM436.04,74.52c.12,0,.23-.02.34-.07.11-.04.2-.11.28-.2.08-.08.15-.19.19-.31.05-.12.07-.26.07-.41,0-.31-.08-.54-.25-.71s-.38-.25-.62-.25-.45.08-.62.25-.25.4-.25.71c0,.15.02.29.07.41.04.12.11.23.19.31s.18.15.28.2c.1.05.22.07.33.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M439,78.08c-.1,0-.18,0-.26-.02-.08-.01-.15-.04-.22-.06l.14-.55.15.04c.06.01.11.02.16.02.24,0,.43-.08.58-.25s.27-.38.35-.63l.09-.31-1.66-4.14h.72l.84,2.29c.06.18.13.37.2.57.07.2.14.4.2.59h.03c.06-.19.12-.38.18-.59s.11-.4.17-.58l.74-2.29h.68l-1.56,4.47c-.07.2-.16.39-.25.57-.09.18-.2.33-.32.45-.12.13-.27.23-.43.3-.16.07-.34.11-.55.11Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M388.37,87.39v-5.87h.58l.06.48h.03c.19-.16.39-.29.62-.41.22-.11.46-.17.7-.17.27,0,.5.05.71.15.2.1.37.24.51.43s.24.41.31.66c.07.26.11.55.11.87,0,.35-.05.66-.14.94-.1.27-.23.51-.39.7-.16.19-.35.34-.57.44-.21.1-.44.15-.68.15-.19,0-.38-.04-.57-.13-.19-.08-.38-.2-.57-.35l.02.72v1.39h-.7ZM390.08,85.17c.17,0,.33-.04.47-.11.14-.08.27-.18.37-.32.1-.14.19-.31.25-.51.06-.2.09-.43.09-.69,0-.23-.02-.43-.06-.62-.04-.19-.1-.35-.19-.48-.09-.13-.2-.24-.34-.31-.14-.07-.3-.11-.5-.11-.18,0-.35.05-.53.14s-.37.24-.57.42v2.17c.19.16.37.27.54.34.18.06.33.1.47.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M393.09,85.65v-4.13h.58l.06.75h.03c.14-.26.31-.47.51-.62.2-.15.42-.23.66-.23.16,0,.31.03.44.08l-.14.61c-.07-.02-.13-.04-.19-.05s-.13-.02-.21-.02c-.18,0-.36.07-.55.21-.19.14-.36.39-.5.74v2.65h-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M396.4,80.67c-.14,0-.25-.04-.34-.13-.09-.08-.14-.19-.14-.32s.05-.25.14-.33c.09-.08.21-.12.34-.12s.25.04.34.12c.09.08.14.19.14.33s-.05.24-.14.32c-.09.08-.21.13-.34.13ZM396.04,85.65v-4.13h.7v4.13h-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M399.76,85.75c-.27,0-.53-.05-.77-.14-.24-.1-.44-.24-.62-.42-.17-.18-.31-.41-.41-.68-.1-.27-.15-.57-.15-.91s.05-.65.16-.92c.11-.27.25-.5.43-.68.18-.19.39-.33.63-.42.24-.1.49-.14.76-.14s.5.05.7.14c.19.1.36.21.51.34l-.36.46c-.12-.11-.25-.2-.38-.26-.13-.07-.28-.1-.45-.1-.19,0-.36.04-.52.11-.16.08-.29.19-.41.33s-.2.31-.27.51c-.07.2-.1.41-.1.65s.03.45.09.65c.06.19.15.36.26.5.11.14.25.25.4.32.16.08.33.11.52.11s.37-.04.53-.12c.16-.08.31-.18.44-.29l.31.47c-.19.16-.39.29-.62.39-.23.09-.46.14-.71.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M403.68,85.75c-.28,0-.54-.05-.78-.15-.24-.1-.45-.24-.63-.42-.18-.18-.32-.41-.42-.68-.1-.27-.15-.57-.15-.91s.05-.64.16-.91.24-.5.42-.68.37-.33.59-.43c.22-.1.45-.15.69-.15.26,0,.49.05.7.14.21.09.38.22.52.39.14.17.25.37.32.61.07.24.11.5.11.8,0,.07,0,.15,0,.22s0,.13-.02.18h-2.79c.03.44.17.79.41,1.05.25.26.57.39.96.39.2,0,.38-.03.55-.09.17-.06.33-.14.48-.23l.25.46c-.18.11-.38.21-.6.3s-.47.13-.76.13ZM402.38,83.25h2.21c0-.42-.09-.74-.27-.96-.18-.22-.43-.33-.75-.33-.15,0-.29.03-.42.08-.13.06-.25.14-.36.25s-.2.25-.27.4-.12.34-.14.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M407.3,85.75c-.29,0-.58-.05-.84-.16s-.5-.24-.7-.41l.35-.47c.18.15.37.27.56.36.19.09.41.14.66.14.27,0,.48-.06.61-.19.14-.12.2-.28.2-.46,0-.11-.03-.2-.08-.28-.06-.08-.13-.15-.22-.21-.09-.06-.19-.11-.3-.16-.11-.05-.23-.09-.34-.14-.15-.05-.29-.11-.44-.17-.15-.06-.28-.14-.4-.24-.12-.09-.21-.2-.28-.33-.07-.12-.11-.27-.11-.45,0-.16.03-.32.1-.46.07-.14.16-.27.28-.37.12-.1.27-.19.45-.25.17-.06.37-.09.59-.09.26,0,.5.05.72.14.22.09.41.2.57.33l-.33.44c-.14-.11-.29-.2-.44-.26s-.32-.1-.5-.1c-.26,0-.45.06-.57.18-.12.12-.18.26-.18.42,0,.1.03.18.08.25.05.07.12.13.2.19s.18.1.29.14c.11.04.23.09.34.13.15.06.3.12.45.18.15.06.29.14.4.23.12.09.22.21.29.34.08.14.11.3.11.49,0,.17-.03.33-.1.48s-.16.28-.29.39c-.13.11-.29.2-.48.27-.19.06-.41.1-.65.1Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvolutionOfEnergyConsumptionBarchartDesktop);
export default __webpack_public_path__ + "static/media/evolution-of-energy-consumption-barchart-desktop.53bbaf881114f109eb9986eb4bc7ee09.svg";
export { ForwardRef as ReactComponent };